import { DrivingExceptionsState } from '../types';

export const drivingExceptionsState: DrivingExceptionsState = {
  hosDriverExceptions: [],
  hosHiddenDriverExceptions: [],
};
